<template>
      <div fluid fill-height>
        <v-expand-x-transition>
          <landing-toolbar />
        </v-expand-x-transition>
        <v-container style="min-width:100% !important">
          <Schedules />
        </v-container>
      </div>
</template>
    
    <script>
   import Schedules from '../../components/Definiciones/Horarios/Schedules.vue';
    import LandingToolbar from '../../components/LandingToolbar/LandingToolbar.vue'
    export default {
      components: { Schedules, LandingToolbar },
    };
    </script>
    